<template>
  <base-layout :layout-classes="layoutClasses"></base-layout>
</template>

<script>
import BaseLayout from "../Base";

export default {
  name: "LayoutBackendNotFooter",
  components: {
    BaseLayout,
  },
  data() {
    return {
      layoutClasses: {
        sideOverlay: "",
        sidebar: "d-block d-sm-none",
        header: "",
        footer: "",
      },
    };
  },
  created() {
    this.$store.commit("setLayout", {
      header: true,
      sidebar: true,
      sideOverlay: true,
      footer: false,
    });
  },
};
</script>
